import React from 'react'
import cc from 'classcat'
import { navigateTo } from 'gatsby-link'

import s from './styles.module.css'

const autoOnClick = ({ anchor, route, onClick, beforeOnClick }) => () => {
  if (typeof beforeOnClick === 'function') {
    beforeOnClick()
  }
  
  if (anchor) {
    document.getElementById(anchor).scrollIntoView({ behavior: 'smooth' })
    return
  }

  if (route) {
    navigateTo(route)
    return
  }

  if (typeof onClick === 'function') {
    onClick()
  }
}

const Button = ({ className, children, ...rest }) => (
  <button
    onClick={autoOnClick({ ...rest })}
    className={cc([s.button, className])}
  >
    {children}
  </button>
)

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/index.js